export default "__VITE_PUBLIC_ASSET__be8ba589__"